module.exports = __webpack_public_path__ + "4d8bfd680fe972eecceca75b1c8f6366.svg";